{% block swag_migration_base_smart_bar_actions %}
    {# <!-- eslint-disable-next-line vue/valid-v-slot --> #}
    <template #smart-bar-actions>
        {% block swag_migration_index_smart_bar_abort_button %}
            <mt-button v-if="abortButtonVisible"
                       variant="secondary"
                       :disabled="abortButtonDisabled"
                       @click="onAbortButtonClick">
                {{ $tc('swag-migration.index.abortButton') }}
            </mt-button>
        {% endblock %}

        {% block swag_migration_index_smart_bar_back_to_overview_button %}
            <mt-button v-if="backToOverviewButtonVisible"
                       variant="primary"
                       :disabled="backToOverviewButtonDisabled"
                       @click="onContinueButtonClick">
                {{ $tc('swag-migration.index.backToOverviewButton') }}
            </mt-button>
        {% endblock %}
    </template>
{% endblock %}

{% block swag_migration_base_content %}
    <template #content>
        <sw-card-view
            v-if="!isLoading && !storesInitializing"
            class="swag-migration-process-screen"
        >
            {% block swag_migration_index_main_page_flow_chart %}
                <sw-step-display
                    v-if="displayFlowChart"
                    class="swag-migration-process-screen__step-display"
                    :item-index="flowChartItemIndex"
                    :item-variant="flowChartItemVariant"
                    :initial-item-variants="flowChartInitialItemVariants"
                >
                    <sw-step-item>
                        {{ $tc('swag-migration.index.loadingScreenCard.flowChart.fetchData') }}
                    </sw-step-item>
                    <sw-step-item>
                        {{ $tc('swag-migration.index.loadingScreenCard.flowChart.errorResolution') }}
                    </sw-step-item>
                    <sw-step-item>
                        {{ $tc('swag-migration.index.loadingScreenCard.flowChart.writeData') }}
                    </sw-step-item>
                    <sw-step-item>
                        {{ $tc('swag-migration.index.loadingScreenCard.flowChart.processMedia') }}
                    </sw-step-item>
                    <sw-step-item>
                        {{ $tc('swag-migration.index.loadingScreenCard.flowChart.cleanup') }}
                    </sw-step-item>
                    <sw-step-item>
                        {{ $tc('swag-migration.index.loadingScreenCard.flowChart.indexing') }}
                    </sw-step-item>
                    <sw-step-item disabled-icon="regular-checkmark-xs">
                        {{ $tc('swag-migration.index.loadingScreenCard.flowChart.finish') }}
                    </sw-step-item>
                </sw-step-display>
            {% endblock %}

            {% block swag_migration_index_main_page_card_loadingScreen %}
                <swag-migration-loading-screen
                    v-if="componentIndex === UI_COMPONENT_INDEX.LOADING_SCREEN"
                    :step="step"
                    :progress="progress"
                    :total="total"
                />
            {% endblock %}

            {% block swag_migration_index_main_page_error_resolution %}
                <swag-migration-error-resolution-step v-if="componentIndex === UI_COMPONENT_INDEX.ERROR_RESOLUTION" />
            {% endblock %}

            {% block swag_migration_index_main_page_card_loadingScreen_success %}
                <swag-migration-result-screen v-if="componentIndex === UI_COMPONENT_INDEX.RESULT_SUCCESS" />
            {% endblock %}

            {% block swag_migration_index_main_page_modal_abort_migration_confirmDialog %}
                <sw-modal
                    v-if="showAbortMigrationConfirmDialog"
                    class="swag-migration-index-modal-abort-migration-confirm-dialog"
                    :title="$tc('swag-migration.index.confirmAbortDialog.title')"
                    variant="small"
                    @modal-close="onCloseAbortMigrationConfirmDialog"
                >
                    {% block swag_migration_index_main_page_modal_abort_migration_confirmDialog_message_hint %}
                        <p class="swag-migration-index-modal-abort-migration-confirm-dialog-hint">
                            {{ $tc('swag-migration.index.confirmAbortDialog.hint') }}
                        </p>
                    {% endblock %}

                    {% block swag_migration_index_main_page_modal_abort_migration_confirmDialog_message %}
                        <p class="swag-migration-index-modal-abort-migration-confirm-dialog-content">
                            {{ $tc('swag-migration.index.confirmAbortDialog.content') }}
                        </p>
                    {% endblock %}

                    {% block swag_migration_index_main_page_modal_abort_migration_confirmDialog_footer %}
                        <template #modal-footer>
                            {% block swag_migration_index_main_page_modal_abort_migration_confirmDialog_footer_cancelAction %}
                                <mt-button
                                    size="small"
                                    variant="secondary"
                                    @click="onCloseAbortMigrationConfirmDialog"
                                >
                                    {{ $tc('swag-migration.index.confirmAbortDialog.cancel') }}
                                </mt-button>
                            {% endblock %}

                            {% block swag_migration_index_main_page_modal_abort_migration_confirmDialog_footer_confirmAction %}
                                <mt-button
                                    variant="critical"
                                    size="small"
                                    :disabled="!acl.can('swag_migration.editor')"
                                    @click="onAbort"
                                >
                                    {{ $tc('swag-migration.index.confirmAbortDialog.confirm') }}
                                </mt-button>
                            {% endblock %}
                        </template>
                    {% endblock %}
                </sw-modal>
            {% endblock %}
        </sw-card-view>

        <mt-loader v-if="isLoading || storesInitializing" />
    </template>
{% endblock %}
